// IssuancePage 配下で共有する UI 非依存の純関数群。

// Materialsの並び順はAPI/IndexedDBともに保証されないため、最小/最大IDで開始・終了番号を求める
export function materialIdRange(materials: { id: number }[]): { head: number; tail: number } {
  if (materials.length === 0) {
    return { head: -1, tail: -1 };
  }
  const ids = materials.map((material) => material.id);
  return { head: Math.min(...ids), tail: Math.max(...ids) };
}
